import Typography from "@/design-system/Typography";
import { CbTopBaseResources } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources";
import { CbTopBaseResourcesEn } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources.En";
import { useViewportInfoContext } from "@/src/contexts";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";
import { ConsentScreenType } from "@/src/modals/useConsents";
import PanelSection from "@/src/shared/panel-section";
import { LoginRegistrationCore } from "@Components/login-registration-core/login-registration-core";
import { TelemetryBoundary } from "@Components/telemetry-hoc/telemetry-boundary";
import type { QuerySmMax } from "@stylex/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

import bgImg from "./../_assets/bg_hero_center.jpg";
import bgImgMobile from "./../_assets/bg_hero_right_mobile.jpg";

import * as css from "./../../CashbackTopSection.module.css";
import * as versionCss from "./lpVersionG.module.css";

export function LpTopComponentVersionG() {
    const ME_VERISON = "G";
    const resources = languageSelector(CbTopBaseResources, CbTopBaseResourcesEn);

    const { isMobile } = useViewportInfoContext();

    return (
        <PanelSection
            telemetryCustom={{
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            className={versionCss.lpVersionG}
            initialInView
        >
            <div className={versionCss.gridWrapper}>
                <div className={css.cashbackTopSectionComponent}>
                    <div className={css.textContent}>
                        <Typography
                            textElement="h1"
                            fontStyle="hXL"
                            styleX={styles.title}
                            dangerouslySetInnerHTML={{ __html: resources.title }}
                        />

                        <Typography
                            textElement="p"
                            fontStyle={isMobile ? "hXS" : "hS"}
                            styleX={styles.subTitle}
                        >
                            {resources.subTitle}
                        </Typography>
                    </div>
                </div>

                <TelemetryBoundary
                    className={versionCss.formContainer}
                    telemetryCustom={{
                        eventName: "common-registerModal",
                        actionType: "View",
                        param1: ME_VERISON,
                    }}
                >
                    <LoginRegistrationCore
                        loginConsentScreenType={ConsentScreenType.LoginProcess}
                        registerConsentScreenType={ConsentScreenType.RegistrationProcess}
                        customRegisterButtonTelemetry={{
                            eventName: "cshbck-topSectionRegister",
                            actionType: "Click",
                            param1: ME_VERISON,
                        }}
                    />
                </TelemetryBoundary>

                <img src={isMobile ? bgImgMobile : bgImg} className={versionCss.bgHero} />
            </div>
        </PanelSection>
    );
}

const smMax: QuerySmMax = "@media (max-width: 989px)";
const styles = stylex.create({
    title: {
        gridRow: { default: "auto", [smMax]: "2/3" },
        color: "white",
        fontSize: { default: "64px", [smMax]: "36px" },
        fontWeight: 300,
        marginBottom: { default: 40, [smMax]: 20 },
        width: { default: "100%", [smMax]: "60%" },
    },
    subTitle: {
        color: "white",
    },
});
